module.exports = __webpack_public_path__ + "img/icone-ordem-texto-maior.314b4f9f.svg";